<template>
  <div class="c-login c-page login">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Velkommen</strong> tilbage
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <div v-if="errorMessage" class="c-error">
          <p class="c-error__text">{{ errorMessage }}</p>
        </div>

        <form class="c-form general-form">
          <input
            ref="email"
            v-model="input.email"
            class="c-form__element"
            type="email"
            name="email"
            placeholder="Email"
          />

          <input
            ref="password"
            v-model="input.password"
            class="c-form__element"
            type="password"
            name="password"
            placeholder="Password"
          />

          <label class="c-form__submit" @click.prevent="login()">
            <SpinnerButton
              ref="loginSpinner"
              class="c-form__submit"
              cta="Login"
              action="Logger ind"
            />

            <input type="submit" value="Login" />
          </label>

          <div class="c-secondary-nav c-login__secondary-nav">
            <router-link :to="{ path: '/opret-bruger', query: query }">Har du ikke en brugerkonto?</router-link>
            <router-link :to="{ path: '/glemt', query: query }">Glemt password?</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
// import ArrowLink from "../components/ArrowLink";
import SpinnerButton from "@/components/SpinnerButton.vue";

const gotos = {
  editorial: 'https://foljeton.dk/'
}

export default {
  name: "Login",
  components: {
    // ArrowLink,
    SpinnerButton
  },
  data() {
    return {
      redirect: this.$route.query.redirect || null,
      goto: this.$route.query.goto || null,
      query: this.$route.query,
      input: {
        email: "",
        password: ""
      },
      errorMessage: ""
    };
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    formalValidation() {
      if (!this.input.email) {
        this.$refs.email.focus();

        return {
          valid: false,
          error: "Du skal skrive din email"
        };
      }
      if (!this.input.password) {
        this.$refs.password.focus();

        return {
          valid: false,
          error: "Du skal skrive dit password"
        };
      }
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const validEmail = this.input.email.match(pattern);

      if (!validEmail) {
        this.$refs.email.focus();

        return {
          valid: false,
          error: "Din email adresse ser ikke helt rigtig ud"
        };
      }

      return { valid: true };
    },
    login() {
      const validation = this.formalValidation();

      console.log(validation);
      if (!validation.valid) {
        this.handleError(validation);
        return;
      }
      //do login
      //console.log(this.$parent)
      this.$userService
        .login({
          email: this.input.email,
          password: this.input.password
        })
        .then(data => {
          //if (data)
          console.log(this.$userService.user);

          if (!this.$userService.user.customer_id) {
            this.$userService.registerCustomer().then(subscription => {
              this.$router.push(
                {
                  name: "creditcard",
                  query: { redirect: "landing" }
                },
                () => {
                  return;
                }
              );
            });
          } else if (this.goto && this.goto in gotos) {

            window.location.href = gotos[this.goto]

          } else if (this.redirect) {
            return this.$router.push({
              name: this.redirect,
              query: this.query
            });
          } else if (this.$userService.user.fljState === "inactive") {
            return this.$router.push({ name: "creditcard", query: this.query });
          } else {
            return this.$router.push({ name: "home" });
          }
        })
        .catch(error => {
          // HAndle error
          console.log("catch", error);
          this.handleError({
            valid: false,
            error: "Vi kan ikke genkende den kombination af email og password"
          });
        });
    },
    handleError(error) {
      this.$refs.loginSpinner.reset();
      this.errorMessage = error.error;
      console.log(error);
    }
  }
};
</script>

<style lang="scss">
@import "../vars";
@import "../_mixins";

.c-login {
  &__secondary-nav {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>